export const getOrganiserInfo = (row = {}) => {
  const user = row.user || {};
  const id = user.id ?? row.user_id ?? row.organiser_id ?? '';
  const forename = user.forename ?? row.user_forename ?? '';
  const surname = user.surname ?? row.user_surname ?? '';
  const name = [forename, surname].filter(Boolean).join(' ').trim();

  return {
    id,
    name,
  };
};

const ticketlabAppBase = () =>
  (process.env.VUE_APP_TICKETLAB_APP_URL || 'https://ticketlab.app').replace(/\/$/, '');

/** Public event edit page on ticketlab.app (optional override via VUE_APP_TICKETLAB_APP_URL). */
export const buildEventEditUrl = (eventId) =>
  `${ticketlabAppBase()}/event/${encodeURIComponent(String(eventId))}#edit`;

/** Public organiser dashboard on ticketlab.app (optional override via VUE_APP_TICKETLAB_APP_URL). */
export const buildUserDashboardUrl = (userId) => {
  return `${ticketlabAppBase()}/dashboard/user/${encodeURIComponent(String(userId))}`;
};

export const buildUserSearchRoute = (userId) => ({
  path: '/search',
  query: {
    searchType: 'user',
    search: String(userId),
    onlyUpcoming: false,
  },
});

export const buildTicketSearchRoute = (ticketCode) => ({
  path: '/search',
  query: {
    searchType: 'ticket',
    search: String(ticketCode),
    onlyUpcoming: false,
  },
});

export const getSearchStateFromQuery = (query = {}) => ({
  search: query.search || '',
  searchBy: query.searchType || 'ticket',
  onlyUpcoming: query.onlyUpcoming === 'true',
});

export const TICKET_RESEND_PATH = '/einstein/ticket/resend';

export const buildTicketResendPayload = (ticketCode) => ({
  ticketCode: String(ticketCode),
});

export const isTicketResendQueued = (data) =>
  Boolean(data && data.status === 'success');

export const isResendTicketDisabled = (
  ticketCode,
  { resentTicketCodes = [], resendingTicketCode = null } = {}
) => {
  const code = String(ticketCode);
  return (
    resentTicketCodes.includes(code) ||
    (resendingTicketCode != null && String(resendingTicketCode) === code)
  );
};

/** Detail lines for the ticket-search event info pane (label/value pairs). */
export const getTicketEventDetailLines = (event = {}) => {
  const lines = [];

  if (event.date) {
    lines.push({ label: 'Date', value: String(event.date) });
  }
  if (event.id != null && event.id !== '') {
    lines.push({ label: 'Event ID', value: String(event.id) });
  }
  if (event.status_type) {
    lines.push({ label: 'Status', value: String(event.status_type) });
  }
  if (event.price != null && event.price !== '') {
    const symbol = event.currency_symbol || '£';
    lines.push({ label: 'Price', value: `${symbol}${event.price}` });
  }
  if (event.url) {
    lines.push({ label: 'URL', value: String(event.url), href: String(event.url) });
  }

  return lines;
};
